import { IsNotEmpty, MaxLength, IsDefined, IsPositive, IsNumber, IsNumberString, ValidateNested, ValidateIf } from 'class-validator';
import * as uuid from 'uuid';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AgentDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.AgentItem, Model.Bookings.Logic.ViewModels.AgentItem, AgentItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.AgentItem): AgentItem {
		return new AgentItemModel(entity);
	}

	static make(ctx?: any): AgentDataService {
		return new AgentDataService(ctx, ctx => ctx.Agents);
	}

	add(managedById: number): Promise<AgentItem> {
		const entity = new Model.Bookings.Logic.ViewModels.AgentItem();

		entity.documentsLibraryId = uuid.v4();
		entity.managedById = managedById;
		(<any>entity).dynamicProperties = {
			'contacts': [],
			'isATOL':false
		};

		return this.create(() => entity);
	}
}

export class AgentItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.AgentItem, AgentItem> implements AgentItem {
	@property<AgentItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<AgentItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	@IsDefined({ message: 'Name is required' })
	@MaxLength(128)
	public name: string;

	@property<AgentItemModel>(o => o.entity.canHaveCredit, (o, value) => o.entity.canHaveCredit = value)
	public canHaveCredit: boolean;

	@property<AgentItemModel>(o => o.entity.creditNumber, (o, value) => o.entity.creditNumber = value)
	@ValidateIf(o => o.canHaveCredit)
	@IsDefined({ message: 'Credit amount is required' })
	public creditNumber: number;

	@property<AgentItemModel>(o => o.entity.currencyId, (o, value) => o.entity.currencyId = value)
	@IsDefined({ message: 'Currency is required' })
	public currencyId: number;

	@property<AgentItemModel>(o => o.entity.currency, (o, value) => o.entity.currency = value)
	public currency: CurrencyItem;

	@property<AgentItemModel>(o => o.entity.responsibleAgentId, (o, value) => o.entity.responsibleAgentId = value)
	public responsibleAgentId?: number;

	@property<AgentItemModel>(o => o.entity.managedById, (o, value) => o.entity.managedById = value)
	@IsDefined({ message: 'Manager user is required' })
	public managedById: number;

	@property<AgentItemModel>(o => o.entity.documentsLibraryId, (o, value) => o.entity.documentsLibraryId = value)
	public documentsLibraryId: string;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: {};

	@property<AgentItemModel>(o => o.entity.brands, (o, value) => o.entity.brands = value)
	@ValidateNested()
	public brands: AgentBrandItem[];

	@property<AgentItemModel>(o => o.entity.policies, (o, value) => o.entity.policies = value)
	@ValidateNested()
	public policies: AgentPolicyItem[];
	@property<AgentItemModel>(o => o.entity.markets, (o, value) => o.entity.markets = value)
	@ValidateNested()
	public markets: AgentMarketItem[];
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/form/agent-form.data.ts